if (!customElements.get("media-gallery")) {
  customElements.define(
    "media-gallery",
    class MediaGallery extends HTMLElement {
      constructor() {
        super();

        this.elements = {
          liveRegion: this.querySelector('[id^="GalleryStatus"]'),
          viewer: this.querySelector('[id^="GalleryViewer"]'),
          thumbnails: this.querySelector('[id^="GalleryThumbnails"]'),
        };

        this.mql = window.matchMedia("(min-width: 750px)");

        if (!this.elements.viewer) return;

        /*
         * Förbered videorna.
         */
        this.getDirectVideos().forEach((video) => {
          video.preload = "auto";
          video.setAttribute("preload", "auto");

          video.playsInline = true;
          video.setAttribute("playsinline", "");
          video.setAttribute("webkit-playsinline", "");

          try {
            video.load();
          } catch (error) {}
        });

        /*
         * När gallery-sliden ändras.
         */
        this.elements.viewer.addEventListener(
          "slideChanged",
          this.onSlideChanged.bind(this)
        );

        /*
         * =========================
         * MOBILE SWIPE
         * =========================
         */
        let pointerStartX = 0;
        let pointerStartY = 0;
        let pointerStartIndex = 0;
        let swipeTargetVideo = null;

        
        this.elements.viewer.addEventListener(
          "pointerdown",
          (event) => {
            if (this.mql.matches || event.pointerType !== "touch") {
              return;
            }

            pointerStartX = event.clientX;
            pointerStartY = event.clientY;
            swipeTargetVideo = null;

            const slides = this.getSlides();
            if (!slides.length) return;

            const activeIndex = slides.findIndex((slide) =>
              slide.classList.contains("is-active")
            );

            if (activeIndex >= 0) {
              pointerStartIndex = activeIndex;
              return;
            }

            const viewerRect =
              this.elements.viewer.getBoundingClientRect();

            const viewerCenter =
              viewerRect.left + viewerRect.width / 2;

            let closestIndex = 0;
            let closestDistance = Infinity;

            slides.forEach((slide, index) => {
              const rect = slide.getBoundingClientRect();

              const slideCenter =
                rect.left + rect.width / 2;

              const distance =
                Math.abs(slideCenter - viewerCenter);

              if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
              }
            });

            pointerStartIndex = closestIndex;
          },
          { passive: true }
        );

        this.elements.viewer.addEventListener(
          "pointermove",
          (event) => {
            if (this.mql.matches || event.pointerType !== "touch") {
              return;
            }

            const differenceX =
              event.clientX - pointerStartX;

            const differenceY =
              event.clientY - pointerStartY;

            /*
             * Vänta tills det verkligen
             * är en horisontell swipe.
             */
            if (Math.abs(differenceX) < 12) {
              return;
            }

            if (
              Math.abs(differenceX) <=
              Math.abs(differenceY)
            ) {
              return;
            }

            const slides = this.getSlides();
            if (!slides.length) return;

            const targetIndex =
              differenceX < 0
                ? Math.min(
                    pointerStartIndex + 1,
                    slides.length - 1
                  )
                : Math.max(
                    pointerStartIndex - 1,
                    0
                  );

            const targetSlide =
              slides[targetIndex];

            if (!targetSlide) return;

            const targetVideo =
              targetSlide.querySelector(
                ".kakelo-product-gallery-video"
              );

            if (
              swipeTargetVideo &&
              swipeTargetVideo !==
                targetVideo
            ) {
              swipeTargetVideo.pause();
            }

            swipeTargetVideo =
              targetVideo;

            /*
             * Stoppa video/ljud från
             * sliden vi lämnar.
             */
            this.pauseInactiveVideos(
              targetSlide
            );

            /*
             * Nästa slide är en bild.
             */
            if (!targetVideo) return;

            /*
             * Om videon redan spelar
             * behöver vi inte starta igen.
             */
            if (!targetVideo.paused) {
              return;
            }

            /*
             * Starta videon REDAN UNDER SWIPEN.
             * Muted här för att mobilen säkert
             * ska tillåta uppspelningen.
             */
            targetVideo.muted = true;
            targetVideo.defaultMuted = true;
            targetVideo.volume = 0;

            targetVideo.loop = true;
            targetVideo.playsInline = true;

            targetVideo.setAttribute(
              "muted",
              ""
            );

            targetVideo.setAttribute(
              "loop",
              ""
            );

            targetVideo.setAttribute(
              "playsinline",
              ""
            );

            targetVideo.setAttribute(
              "webkit-playsinline",
              ""
            );

            
            const playPromise =
              targetVideo.play();

            if (
              playPromise &&
              typeof playPromise.catch ===
                "function"
            ) {
              playPromise.catch(
                function () {}
              );
            }
          },
          { passive: true }
        );

        this.elements.viewer.addEventListener(
          "pointerup",
          (event) => {
            if (this.mql.matches || event.pointerType !== "touch") {
              return;
            }

            const differenceX =
              event.clientX - pointerStartX;

            const differenceY =
              event.clientY - pointerStartY;

            /*
             * Inte en riktig horisontell swipe.
             */
            if (
              Math.abs(differenceX) < 20 ||
              Math.abs(differenceX) <=
                Math.abs(differenceY)
            ) {
              if (swipeTargetVideo) {
                swipeTargetVideo.pause();
              }

              swipeTargetVideo = null;

              return;
            }

            const slides =
              this.getSlides();

            if (!slides.length) return;

            const targetIndex =
              differenceX < 0
                ? Math.min(
                    pointerStartIndex + 1,
                    slides.length - 1
                  )
                : Math.max(
                    pointerStartIndex - 1,
                    0
                  );

            const targetSlide =
              slides[targetIndex];

            if (!targetSlide) return;

            /*
             * Stoppa alla videor som inte
             * tillhör sliden vi går till.
             */
            this.pauseInactiveVideos(
              targetSlide
            );

            const targetVideo =
              targetSlide.querySelector(
                ".kakelo-product-gallery-video"
              );

            /*
             * Swipe till vanlig bild.
             */
            if (!targetVideo) {
              swipeTargetVideo = null;
              return;
            }

            /*
             * Videon har redan fått chans
             * att börja under pointermove.
             *
             * Nu försöker vi slå på ljudet
             * direkt när fingret släpps.
             */
            targetVideo.removeAttribute(
              "muted"
            );

            targetVideo.muted = false;
            targetVideo.defaultMuted = false;
            targetVideo.volume = 1;

            targetVideo.loop = true;
            targetVideo.playsInline = true;

            targetVideo.setAttribute(
              "loop",
              ""
            );

            targetVideo.setAttribute(
              "playsinline",
              ""
            );

            targetVideo.setAttribute(
              "webkit-playsinline",
              ""
            );

            targetVideo.removeAttribute(
              "controls"
            );

            try {
              targetVideo.disablePictureInPicture =
                true;
            } catch (error) {}

            const playPromise =
              targetVideo.play();

            if (
              playPromise &&
              typeof playPromise.then ===
                "function"
            ) {
              playPromise
                .then(() => {
                  targetVideo.removeAttribute(
                    "muted"
                  );

                  targetVideo.muted =
                    false;

                  targetVideo.defaultMuted =
                    false;

                  targetVideo.volume = 1;
                })
                .catch(() => {
                  /*
                   * Om Safari blockerar ljud
                   * efter swipe:
                   * fortsätt spela videon muted
                   * istället för att visa stillbild.
                   */
                  targetVideo.muted = true;
                  targetVideo.defaultMuted =
                    true;
                  targetVideo.volume = 0;

                  targetVideo.setAttribute(
                    "muted",
                    ""
                  );

                  const fallbackPlay =
                    targetVideo.play();

                  if (
                    fallbackPlay &&
                    typeof fallbackPlay.catch ===
                      "function"
                  ) {
                    fallbackPlay.catch(
                      function () {}
                    );
                  }
                });
            }

            swipeTargetVideo = null;
          },
          { passive: true }
        );

        /*
         * =========================
         * THUMBNAILS
         * =========================
         */
        if (this.elements.thumbnails) {
          this.elements.thumbnails
            .querySelectorAll(
              "[data-target]"
            )
            .forEach((mediaToSwitch) => {
              const button =
                mediaToSwitch.querySelector(
                  "button"
                );

              if (!button) return;

              button.addEventListener(
                "click",
                this.setActiveMedia.bind(
                  this,
                  mediaToSwitch.dataset.target,
                  false
                )
              );
            });
        }

        if (
          this.elements.thumbnails &&
          this.dataset.desktopLayout &&
          this.dataset.desktopLayout.includes(
            "thumbnail"
          ) &&
          this.mql.matches
        ) {
          this.removeListSemantic();
        }
      }

      /*
       * Hämta endast riktiga gallery-slides.
       */
      getSlides() {
        const viewerList =
          this.elements.viewer.querySelector(
            ".product__media-list"
          );

        if (!viewerList) return [];

        return Array.from(
          viewerList.querySelectorAll(
            ":scope > .product__media-item"
          )
        );
      }

      /*
       * Alla direkta produktvideor.
       */
      getDirectVideos() {
        return Array.from(
          this.elements.viewer.querySelectorAll(
            ".kakelo-product-gallery-video"
          )
        );
      }

      /*
       * Säkerställ att vi arbetar
       * med själva gallery-sliden.
       */
      normalizeSlide(element) {
        if (!element) return null;

        if (
          element.classList?.contains(
            "product__media-item"
          )
        ) {
          return element;
        }

        return (
          element.closest?.(
            ".product__media-item"
          ) || null
        );
      }

      /*
       * När aktiv slide ändras.
       */
      onSlideChanged(event) {
        const currentSlide =
          this.normalizeSlide(
            event.detail?.currentElement
          );

        if (!currentSlide) return;

        if (this.elements.thumbnails) {
          const thumbnail =
            this.elements.thumbnails.querySelector(
              `[data-target="${currentSlide.dataset.mediaId}"]`
            );

          this.setActiveThumbnail(
            thumbnail
          );
        }

        /*
         * Stoppa alla videos som inte
         * ligger på den aktiva sliden.
         */
        this.pauseInactiveVideos(
          currentSlide
        );

        /*
         * På mobil hanteras starten
         * av swipe eller thumbnail-klick.
         */
        if (!this.mql.matches) return;

        /*
         * Desktop.
         */
        this.playActiveMedia(
          currentSlide
        );
      }

      /*
       * Klick på thumbnail.
       */
      setActiveMedia(
        mediaId,
        prepend
      ) {
        const slides =
          this.getSlides();

        const activeMedia =
          slides.find(
            (slide) =>
              slide.dataset.mediaId ===
              mediaId
          );

        if (!activeMedia) return;

        slides.forEach((element) => {
          element.classList.remove(
            "is-active"
          );
        });

        activeMedia.classList.add(
          "is-active"
        );

        if (prepend) {
          activeMedia.parentElement.prepend(
            activeMedia
          );

          if (
            this.elements.thumbnails
          ) {
            const activeThumbnail =
              this.elements.thumbnails.querySelector(
                `[data-target="${mediaId}"]`
              );

            if (activeThumbnail) {
              activeThumbnail.parentElement.prepend(
                activeThumbnail
              );
            }
          }

          if (
            this.elements.viewer.slider
          ) {
            this.elements.viewer.resetPages();
          }
        }

        this.preventStickyHeader();

        window.setTimeout(() => {
          activeMedia.parentElement.scrollTo(
            {
              left:
                activeMedia.offsetLeft,
            }
          );
        });

        /*
         * Stoppa tidigare video.
         */
        this.pauseInactiveVideos(
          activeMedia
        );

        /*
         * Thumbnail-klick:
         * behåll det som redan fungerar.
         */
        this.playActiveMedia(
          activeMedia
        );

        if (
          !this.elements.thumbnails
        ) {
          return;
        }

        const activeThumbnail =
          this.elements.thumbnails.querySelector(
            `[data-target="${mediaId}"]`
          );

        this.setActiveThumbnail(
          activeThumbnail
        );

        if (activeThumbnail) {
          this.announceLiveRegion(
            activeMedia,
            activeThumbnail.dataset
              .mediaPosition
          );
        }
      }

      setActiveThumbnail(
        thumbnail
      ) {
        if (
          !this.elements.thumbnails ||
          !thumbnail
        ) {
          return;
        }

        this.elements.thumbnails
          .querySelectorAll("button")
          .forEach((element) =>
            element.removeAttribute(
              "aria-current"
            )
          );

        const button =
          thumbnail.querySelector(
            "button"
          );

        if (!button) return;

        button.setAttribute(
          "aria-current",
          true
        );

        if (
          typeof this.elements
            .thumbnails
            .isSlideVisible ===
            "function" &&
          this.elements.thumbnails.isSlideVisible(
            thumbnail,
            10
          )
        ) {
          return;
        }

        if (
          this.elements.thumbnails.slider
        ) {
          this.elements.thumbnails.slider.scrollTo(
            {
              left:
                thumbnail.offsetLeft,
            }
          );
        }
      }

      announceLiveRegion(
        activeItem,
        position
      ) {
        const image =
          activeItem.querySelector(
            ".product__modal-opener--image img"
          );

        if (
          !image ||
          !this.elements.liveRegion
        ) {
          return;
        }

        image.onload = () => {
          this.elements.liveRegion.setAttribute(
            "aria-hidden",
            false
          );

          this.elements.liveRegion.innerHTML =
            window.accessibilityStrings.imageAvailable.replace(
              "[index]",
              position
            );

          setTimeout(() => {
            this.elements.liveRegion.setAttribute(
              "aria-hidden",
              true
            );
          }, 2000);
        };

        image.src = image.src;
      }

      /*
       * Video + ljud på.
       */
      prepareVideoWithSound(video) {
        if (!video) return;

        video.removeAttribute(
          "muted"
        );

        video.muted = false;
        video.defaultMuted = false;
        video.volume = 1;

        video.loop = true;
        video.playsInline = true;

        video.setAttribute(
          "loop",
          ""
        );

        video.setAttribute(
          "playsinline",
          ""
        );

        video.setAttribute(
          "webkit-playsinline",
          ""
        );

        video.removeAttribute(
          "controls"
        );

        try {
          video.disablePictureInPicture =
            true;
        } catch (error) {}
      }

      /*
       * Starta direktvideo med ljud.
       */
      playDirectVideo(video) {
        if (!video) return;

        this.prepareVideoWithSound(
          video
        );

        const playPromise =
          video.play();

        if (
          playPromise &&
          typeof playPromise.then ===
            "function"
        ) {
          playPromise
            .then(() => {
              this.prepareVideoWithSound(
                video
              );
            })
            .catch(function () {});
        }
      }

      /*
       * Stoppa videos som inte ligger
       * på aktiv gallery-slide.
       */
      pauseInactiveVideos(
        activeSlide
      ) {
        const slides =
          this.getSlides();

        slides.forEach((slide) => {
          if (
            slide === activeSlide
          ) {
            return;
          }

          const video =
            slide.querySelector(
              ".kakelo-product-gallery-video"
            );

          if (video) {
            video.pause();
          }
        });
      }

      /*
       * Starta aktiv media.
       */
      playActiveMedia(
        activeItem
      ) {
        if (!activeItem) return;

        const directVideo =
          activeItem.querySelector(
            ".kakelo-product-gallery-video"
          );

        if (directVideo) {
          this.playDirectVideo(
            directVideo
          );

          return;
        }

        if (
          typeof window.pauseAllMedia ===
          "function"
        ) {
          window.pauseAllMedia();
        }

        const deferredMedia =
          activeItem.querySelector(
            ".deferred-media"
          );

        if (deferredMedia) {
          deferredMedia.loadContent(
            false
          );
        }
      }

      preventStickyHeader() {
        this.stickyHeader =
          this.stickyHeader ||
          document.querySelector(
            "sticky-header"
          );

        if (!this.stickyHeader) {
          return;
        }

        this.stickyHeader.dispatchEvent(
          new Event(
            "preventHeaderReveal"
          )
        );
      }

      removeListSemantic() {
        if (
          !this.elements.viewer.slider
        ) {
          return;
        }

        this.elements.viewer.slider.setAttribute(
          "role",
          "presentation"
        );

        this.elements.viewer.sliderItems.forEach(
          (slide) =>
            slide.setAttribute(
              "role",
              "presentation"
            )
        );
      }
    }
  );
}